import { reactive } from "@vue/composition-api";
import { User } from "@/store/modules/users";

export const enum UserStatus {
  active = "active",
  inactive = "inactive",
}

export const enum UserPermissionLevel {
  fieldWorker = "field_worker",
  officeWorker = "office_worker",
  admin = "admin",
}

const prettifiedUserStatus = {
  active: "Active",
  inactive: "Inactive",
};

const prettifiedUserPermissionLevel = {
  field_worker: "Field Worker",
  office_worker: "Office Worker",
  admin: "Admin",
};

export const prettifyUserStatus = (s: UserStatus) => {
  return prettifiedUserStatus[s];
};

export const prettifyUserPermissionLevel = (p: UserPermissionLevel) => {
  return prettifiedUserPermissionLevel[p];
};

export const userStatusReverseLookup = <{ [key: string]: UserStatus }>{
  active: UserStatus.active,
  inactive: UserStatus.inactive,
};

export const userPermissionLevelReverseLookup = <
  { [key: string]: UserPermissionLevel }
>{
  field_worker: UserPermissionLevel.fieldWorker,
  office_worker: UserPermissionLevel.officeWorker,
  admin: UserPermissionLevel.admin,
};

export interface FormUser {
  id: string;
  name: string;
  email: string;
  password: string;
  status: string;
  permission_level: string;
}

export function buildFormUser() {
  let formUser = reactive<FormUser>({
    id: "",
    name: "",
    email: "",
    password: "",
    status: UserStatus.active,
    permission_level: UserPermissionLevel.fieldWorker,
  });

  let loadUserIntoForm = (u: User, formU: FormUser) => {
    formU.id = u.id;
    formU.name = u.name;
    formU.email = u.email;
    formU.permission_level = u.permission_level;
    formU.status = u.status;
  };

  let userStatuses = reactive<UserStatus[]>([]);
  let userPermissionLevels = reactive<UserPermissionLevel[]>([]);

  const loadUserStatusesIntoForm = (uStatuses: UserStatus[]) => {
    uStatuses.push(UserStatus.active, UserStatus.inactive);
  };

  const loadUserPermissionLevelsIntoForm = (
    uPermissions: UserPermissionLevel[],
  ) => {
    uPermissions.push(
      UserPermissionLevel.fieldWorker,
      UserPermissionLevel.officeWorker,
      UserPermissionLevel.admin,
    );
  };

  return {
    formUser,
    loadUserIntoForm,
    userStatuses,
    userPermissionLevels,
    loadUserStatusesIntoForm,
    loadUserPermissionLevelsIntoForm,
  };
}
